import { useEffect, useState } from 'react'
import adminCss from './sass/adminpage.module.scss'

import { formatMoney } from 'services/util'

export default function StatSummary(props) {

  const [totalNumBids, setTotalNumBids] = useState(0)
  const [totalAmountBid, setTotalAmountBid] = useState(0)
  const [totalNumPurchases, setTotalNumPurchases] = useState(0)
  const [totalAmountPurchases, setTotalAmountPurchases] = useState(0)
  const [totalNumItems, setTotalNumItems] = useState(0)
  const [totalDonations, setTotalDonations] = useState(0)

  const [totalAttendees, setTotalAttendees] = useState(0)
  const [totalAttendeesBidding, setTotalAttendeesBidding] = useState(0)
  const [isPublic, setIsPublic] = useState(false)

  //use effect for item/bid calculations
  useEffect(() => {
      if (props.auction) {

        let itemCount = 0
        
        if (props.auction.Bids && props.auction.Items) {
          let bidCount = 0, bidAmount = 0
    
          props.auction.Items.forEach(item => {
            bidCount += item.BidCount
            bidAmount += item.CurrentBid
            itemCount += 1
          })

          setTotalNumBids(bidCount)
          setTotalAmountBid(bidAmount)
        }

        if (props.auction.FixedItems) {
          let purchaseCount = 0, purchaseAmount = 0

          props.auction.FixedItems.forEach(item => {
            purchaseCount += item.TotalItemsPurchased
            purchaseAmount += (item.TotalItemsPurchased * item.PurchasePrice)
            itemCount += 1
          })

          setTotalNumPurchases(purchaseCount)
          setTotalAmountPurchases(purchaseAmount)
        }

        setTotalDonations(props.auction.TotalDonations)
        setTotalNumItems(itemCount)
      }

    }, [props.auction])

  // use effect for registration calculations
  useEffect(() => {
      if (props.auction && props.auction.Registrations && props.auction.Registrations.length > 0) {
        const uniqueUserCount = new Set(props.auction.Registrations.map(reg => reg.User.UserId)).size
        setTotalAttendees(uniqueUserCount)
      }

      if (props.auction && props.auction.Bids && props.auction.Bids.length > 0) {
        const uniqueUsersBidding = new Set(props.auction.Bids.map(bid => bid.UserId)).size
        setTotalAttendeesBidding(uniqueUsersBidding)
      }

      if (props.auction.Status === 'PREVIEW') setIsPublic(false)
      else setIsPublic(true)

    }, [props.auction])


  return (
    <div className={adminCss['admin-auction-items-bidcounts']}>
      <p><b>Number of Items:</b> {totalNumItems}</p>
      {isPublic && props.auction.Items?.length > 0 && 
        <p><b>Bids:</b> {totalNumBids} total, ${formatMoney(totalAmountBid)} raised</p>}
      {isPublic && props.auction.FixedItems?.length > 0 && 
        <p><b>Purchases:</b> {totalNumPurchases} total, ${formatMoney(totalAmountPurchases)} raised</p>}
      {isPublic && props.auction.HasDonation && 
        <p><b>Donations:</b> ${formatMoney(totalDonations)} total</p>}
      {isPublic && <p><b>Attendees:</b> {totalAttendees} total, {totalAttendeesBidding} bidding</p>}
    </div>
  )
}